// extracted by mini-css-extract-plugin
export default {"iconStyle":"style-module--iconStyle--1c3f0"};